import { sendGTMEvent } from "@next/third-parties/google";

export const trackEvent = (eventName: string, data: Record<string, any>) => {
  sendGTMEvent({
    event: eventName,
    ...data,
  });
};
